// TUT-537 — Defesas, a biblioteca por documento (D36): só leitura. `GET
// /defesas` devolve um documento finalizado por linha, com a ficha que vale, e
// `GET /defesas/opcoes`, quem aparece nela (para a barra de filtros).
//
// O demo vem DIRETO de `../demo/defesas`, e não pelo `demoApi`: o
// `demo-data.ts` está no teto da catraca de tamanho e não tem folga nem para
// duas linhas (o mesmo caminho da consulta normativa). O `useDemoApi` é lido
// aqui — o empacotador só dobra a constante no módulo que a escreve —, e a
// trava do bundle reprova se o demo vazar.
import { defesasDaDemo, opcoesDasDefesasDaDemo } from "../demo/defesas";
import type { DefesasQuery, DefesasResponse, OpcoesDasDefesas } from "../types";
import { request } from "./infra";

const useDemoApi = import.meta.env.VITE_API_MODE === "demo";

/** Os filtros viram a query do contrato: a chave que repete (documento, objetos, agentes) vai uma vez por valor. */
export function consultaDasDefesas(filtros: DefesasQuery): string {
  const busca = new URLSearchParams();
  for (const [chave, valor] of Object.entries(filtros)) {
    if (valor === undefined || valor === "") continue;
    if (Array.isArray(valor)) {
      for (const item of valor) busca.append(chave, String(item));
    } else {
      busca.set(chave, String(valor));
    }
  }
  const texto = busca.toString();
  return texto ? `?${texto}` : "";
}

export const apiDasDefesas = {
  defesas(filtros: DefesasQuery): Promise<DefesasResponse> {
    if (useDemoApi) return defesasDaDemo(filtros);
    return request<DefesasResponse>(`/defesas${consultaDasDefesas(filtros)}`);
  },
  opcoesDasDefesas(): Promise<OpcoesDasDefesas> {
    if (useDemoApi) return opcoesDasDefesasDaDemo();
    return request<OpcoesDasDefesas>("/defesas/opcoes");
  },
};
